import React from 'react';

import Layout from '../../../components/Layout';
import TalkableWidget from '../../../components/TalkableWidget';

const Invite = () => (
  <Layout pageTitle="Invite Friends" isProtected>
    <div className="page-content">
      <TalkableWidget />
    </div>
  </Layout>
);

export default Invite;
